import ReactDOM from "react-dom";

function createOverlay(map, api, position, content) {
  const overlayDiv = document.createElement("div");
  overlayDiv.style.position = "absolute";
  const overlay = new api.OverlayView();
  overlay.onAdd = function () {
    const panes = this.getPanes();
    if (!panes) return;

    panes.floatPane.appendChild(overlayDiv);
  };
  overlay.draw = function () {
    const projection = this.getProjection();
    const point = projection.fromLatLngToDivPixel(
      new api.LatLng(position.latitude, position.longitude)
    );
    if (point) {
      overlayDiv.style.left = `${point.x}px`;
      overlayDiv.style.top = `${point.y - 40}px`;
    }
  };

  overlay.onRemove = function () {
    ReactDOM.unmountComponentAtNode(overlayDiv);
    overlayDiv.parentNode && overlayDiv.parentNode.removeChild(overlayDiv);
  };
  const closeOverlay = () => {
    overlay.setMap(null);
  };
  ReactDOM.render(content(closeOverlay), overlayDiv);
  overlay.setMap(map);
  return overlay;
}

export { createOverlay };
